import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'RoutesFormTitle',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    value: {
      type: Object,
      required: true
    },
    service: {
      type: String,
      required: true
    }
  },

  computed: {
    $component() {
      if (this.value.id) {
        return 'router-link'
      }

      return 'div'
    },

    $to() {
      const result = {}
      if (this.value.id) {
        result.name = [ this.service, 'single' ].join('.')
        result.params = { id: this.value.id }
      }

      return result
    },

    $icon() {
      if (this.value.id) {
        return 'link'
      }

      return 'link_off'
    }
  },

  render
}
